import React from 'react'

function ChoiceDLA() {
  return (
    <>
        <div className='container' id="c-sectionlenderChoice">
            <div className="d-flex w-100 flex-column mb-4">
                <h5 className="mt-4 mb-4 pt-4">
                    Name of the Lending Partner
                </h5>
                <div className="d-flex justify-content-between">
                    <img src="./images/logo/choice1.png" alt="Choice" style={{width: '120px'}}/>
                   {/*  <div className="d-flex flex-column">
                        <span className="text-dark">Name of Loan Service Provider (LSP)</span>
                        <span className="text-muted">Choice International Limited</span>
                    </div> */}
                </div>
                <div className='mt-4'>
                    <p className="mt-1 mb-2">
                        <span class="text-muted font-weight-bold">Lender Name: </span>
                        <p>Choice Finserv Pvt. Ltd. </p>
                    </p>
                    <p className="mt-1 mb-2">
                        <span class="text-muted font-weight-bold">Web URL: </span>
                        <a className="text-success" target="_blank" href="https://choiceindia.com/">https://choiceindia.com/</a>
                    </p>
                    
                   {/*  <p className="mt-1 mb-1">
                        <span className="text-muted font-weight-bold">App Store: </span>
                        <a className="text-success" target="_blank" href="https://apps.apple.com/us/app/choice-finx-formerly-jiffy/id1327801261?ls=1">https://apps.apple.com/us/app/choice-finx-formerly-jiffy/id1327801261?ls=1</a>
                    </p> */}
                </div>
            </div>

            <div className="accordion" id="accordionExample">
                <div className="card border-0 pt-3">
                    <div className="card-header bg-light border-bottom-0" id="headingOne">
                        <h2 className="mb-0">
                            <div className="btn btn-link btn-block text-left text-dark" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Details of Nodal Officer and Grievance Redressal Official (GRO)
                            </div>
                        </h2>
                    </div>

                    <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div className="card-body">
                            <h6 className="text-dark font-weight-bold">Mr. Arun Rathore</h6>
                            <div className="d-flex flex-row">
                                <div>
                                    <div className="mb-3 mt-3">
                                        <p className="font-weight-bold text-muted">Designation:</p>
                                        <div className="DLPDetails_officerDetailsRowValue__9gYCi">Grievance Redressal Officer</div>
                                    </div>
                                    <div className="mb-3 ">
                                        <p className="font-weight-bold text-muted">Contact no:</p>
                                        <div className="text-muted">+91 8104312358 <br />   (Monday to Friday between 10 AM - 7 PM)</div>
                                    </div>
                                    <div className="mb-3">
                                        <p className="font-weight-bold text-muted">GRO Email:</p>
                                        <div className="text-muted">
                                            <a className="text-success" href="mailto:arun.rathore@choiceindia.com">arun.rathore@choiceindia.com</a>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <p className="font-weight-bold text-muted">Address:</p>
                                        <div className="text-muted">
                                            29, Girdhar Marg, Lal Bahadur Nagar East, Lal Bahadur Nagar, Sunder Nagar, Malviya Nagar, Jaipur, Rajasthan 302017
                                        </div>
                                    </div>
                                </div>
                                {/* <div>
                                    <div className="mb-3 mt-3">
                                        <p className="font-weight-bold text-dark">Privacy Policy of the Choice:</p>
                                        <div className="DLPDetails_officerDetailsRowValue__9gYCi">
                                            <a className="text-success" href='https://choiceindia.com/privacy-policy' target="_blank">https://choiceindia.com/privacy-policy</a>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div class="card border-0 mt-5">
                    <div class="card-header border-0" id="headingTwo">
                    <h2 class="mb-0">
                        <div class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Details of the Grievance and Nodal Officer of PayU Finance India Private Limited (Regulated Entity)
                        </div>
                    </h2>
                    </div>
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample">
                        <div class="card-body">
                            <div className="DLPDetails_officerDetailsGrid__8BmfQ">
                                <h6 className="text-dark">Mr. Arun Rathore</h6>
                                <div>
                                    <div className="mb-3 mt-3">
                                        <p className="font-weight-bold text-muted">Designation:</p>
                                        <div className="DLPDetails_officerDetailsRowValue__9gYCi">Grievance Redressal Officer</div>
                                    </div>
                                    <div className="mb-3 ">
                                        <p className="font-weight-bold text-muted">Contact no:</p>
                                        <div className="text-muted">+91 8104312358 <br />   (Monday to Friday between 10 AM - 7 PM)</div>
                                    </div>
                                    <div className="mb-3">
                                        <p className="font-weight-bold text-muted">GRO Email:</p>
                                        <div className="text-muted">
                                            <a className="text-success" href="mailto:arun.rathore@choiceindia.com">arun.rathore@choiceindia.com</a>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <p className="font-weight-bold text-muted">Address:</p>
                                        <div className="text-muted">
                                            29, Girdhar Marg, Lal Bahadur Nagar East, Lal Bahadur Nagar, Sunder Nagar, Malviya Nagar, Jaipur, Rajasthan 302017
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card border-0 mt-5">
                    <div class="card-header border-0" id="headingThree">
                        <h2 class="mb-0">
                            <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Details of collections agencies
                            </button>
                        </h2>
                    </div>
                    <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample">
                        <div class="card-body">
                            <div className="DLPDetails_officerDetailsGrid__8BmfQ">
                                <h6 className="text-dark">Mr. Arun Rathore</h6>
                                <div>
                                    <div className="mb-3 mt-3">
                                        <p className="font-weight-bold text-muted">Designation:</p>
                                        <div className="DLPDetails_officerDetailsRowValue__9gYCi">Grievance Redressal Officer</div>
                                    </div>
                                    <div className="mb-3 ">
                                        <p className="font-weight-bold text-muted">Contact no:</p>
                                        <div className="text-muted">+91 8104312358 <br />   (Monday to Friday between 10 AM - 7 PM)</div>
                                    </div>
                                    <div className="mb-3">
                                        <p className="font-weight-bold text-muted">GRO Email:</p>
                                        <div className="text-muted">
                                            <a className="text-success" href="mailto:arun.rathore@choiceindia.com">arun.rathore@choiceindia.com</a>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <p className="font-weight-bold text-muted">Address:</p>
                                        <div className="text-muted">
                                            29, Girdhar Marg, Lal Bahadur Nagar East, Lal Bahadur Nagar, Sunder Nagar, Malviya Nagar, Jaipur, Rajasthan 302017
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                </div>

            
        </div>
    </>
  )
}

export default ChoiceDLA